/* src/app/components/staff-room/topic-details/topic-tile-view/topic-tile-view.component.css */
.topTileview {
  margin: 15.8px 30px !important;
  border-radius: 0px !important;
}
.topTileview .tile .title {
  font-size: 14px;
  font-weight: 800;
  -webkit-animation: reverse;
  -webkit-animation-delay: 0s;
  -webkit-animation-direction: alternate;
}
.topTileview .tile .subtitle {
  font-size: 13px;
  color: #ccc;
}
.topTileview .tile .tileViewFooter {
  min-height: 0;
}
/*# sourceMappingURL=topic-tile-view.component.css.map */
